// We need to revamp our error handling strategy,
// For now, hardcoding types is the solution.
export enum ErrorMessagesToIgnore {
  TEMPLATE_NOT_FOUND = 'TEMPLATE_NOT_FOUND',
  INTEGRATION_FAILED = 'INTEGRATION_FAILED',
  TEMPLATE_IO_EXCEPTION = 'TEMPLATE_IO_EXCEPTION',
  DUPLICATE_ACCOUNT = 'DUPLICATE_ACCOUNT',
}

export enum ErrorMessagePathsToIgnore {
  WORKFLOW_COUNTS = 'workflowCounts',
}
